// Import ENV config
import config from '../config'

const secretKey = config.general.secretKey;

export default secretKey